'use client'

import { useParams } from 'next/navigation'
import { ComponentProps, MouseEvent } from 'react'

import { contractQueries } from '@/entities/contract'
import { usePrefetchQuery } from '@/shared/api'
import { useDialog } from '@/shared/lib'
import { TextButton } from '@/shared/ui'

import { UpdateDepositReturnCardDialog } from './dialog'

export const DIALOG = {
  UPDATE_DEPOSIT_RETURN_CARD: 'DEPOSIT_RETURN_CARD',
} as const

type Props = ComponentProps<typeof TextButton> & {
  contractId?: number
}

export const UpdateDepositReturnCardButton = ({
  contractId: contractIdProp,
  onClick,
  children,
  ...restProps
}: Props) => {
  const params = useParams()
  const contractId = (() => {
    if (contractIdProp) {
      return contractIdProp
    }

    return Number(params?.contractId)
  })()

  const { isOpen, open, closeHandler } = useDialog()

  const { prefetch } = usePrefetchQuery()

  const handleClick = async (event: MouseEvent<HTMLButtonElement>) => {
    if (!contractId) {
      return
    }

    const { success } = await prefetch(
      contractQueries.guestDepositReturnCard({ contractId }),
    )

    if (!success) {
      return
    }

    onClick?.(event)
    open(DIALOG.UPDATE_DEPOSIT_RETURN_CARD)
  }

  return (
    <>
      <TextButton
        size="small"
        weight="normal"
        onClick={handleClick}
        {...restProps}
      >
        {children}
      </TextButton>

      <UpdateDepositReturnCardDialog
        isOpen={isOpen(DIALOG.UPDATE_DEPOSIT_RETURN_CARD)}
        onOpenChange={closeHandler(DIALOG.UPDATE_DEPOSIT_RETURN_CARD)}
        contractId={contractId}
      />
    </>
  )
}
